var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer relative",class:_vm.iconSize,on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('base-icon',{attrs:{"name":_vm.name,"size":_vm.size,"custom":_vm.custom}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }